import { isNewSeries } from "../../utils/showFields.js";
import { getPrimaryRating } from "../../utils/showRatings.js";

export const MONTH_FILTERS = [
  { value: "all", label: "All premieres" },
  { value: "new", label: "New" },
  { value: "returning", label: "Returning" },
];

export const MONTH_SORTS = [
  { value: "date", label: "Release date" },
  { value: "rating", label: "Rating" },
];

export const DEFAULT_MONTH_TOOLS = { filter: "all", sort: "date" };

// Filters by new series (season 1) or returning seasons, then sorts. "date"
// keeps the payload order; "rating" puts the highest first and unrated last.
export function applyMonthTools(shows, { filter, sort } = DEFAULT_MONTH_TOOLS) {
  const list = Array.isArray(shows) ? shows : [];
  const filtered = filter === "new"
    ? list.filter(isNewSeries)
    : filter === "returning"
      ? list.filter((show) => !isNewSeries(show))
      : list;

  if (sort !== "rating") return filtered;

  return filtered
    .map((show, index) => ({ show, index, rating: getPrimaryRating(show) }))
    .sort((a, b) => {
      if (a.rating === null || b.rating === null) {
        return (a.rating === null) - (b.rating === null) || a.index - b.index;
      }
      return b.rating - a.rating || a.index - b.index;
    })
    .map(({ show }) => show);
}

export function describeEmptyMonth(filter, label) {
  return filter === "new"
    ? `No new shows in ${label}.`
    : filter === "returning"
      ? `No returning shows in ${label}.`
      : `No premieres in ${label}.`;
}
